import ContentManage from './contentManage'
import ContentDetail from './detail'
import ContentView from './view'
import ContentPreview from './preview'
import ContentLabel from './label'
import ContentRecord from './record'
import TaskInfo from './task/taskInfo'
import TaskEdit from './task/taskEdit'
import TaskRecord from './task/taskRecord'
import TaskNotice from './task/taskNotice'

export {
  ContentManage,
  ContentDetail,
  ContentView,
  ContentPreview,
  ContentLabel,
  ContentRecord,
  TaskInfo,
  TaskEdit,
  TaskRecord,
  TaskNotice,
}
